<script>
import GlyphComponent from "@/components/GlyphComponent";
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";
import PrimaryButton from "@/components/PrimaryButton";

export default {
  name: "RealityModal",
  components: {
    PrimaryButton,
    ModalWrapperChoice,
    GlyphComponent,
  },
  data() {
    return {
      firstReality: false,
      hasSpace: true,
      hasChoice: false,
      hasFilter: false,
      glyphs: [],
      bestLevel: 0,
      levelDifference: 0,
      selectedGlyph: undefined,
      canRefresh: false,
      level: 0,
      simRealities: 0,
      realityMachines: new Decimal(),
      shardsGained: 0,
      effarigUnlocked: false,
      willAutoPurge: false,
    };
  },
  computed: {
    firstRealityText() {
      return `Реальность сбросит всё, за исключением рекордов Челленджей и всем под заголовком Основное во вкладке
        Статистики. Первые ${formatInt(13)} рядов Достижений также сброшены,
        но вы будете автоматически получать одно потерянное Достижение каждые
        ${timeDisplayNoDecimals(30 * 60000)}. Вы также получите Машины Реальности, основываясь на ваших Очках Вечности,
        Глиф с уровнем, основанным на ваших Очках Вечности, Репликантах, и Растянутом Времени, Очко Перка, созданное для
        улучшений качества жизни, и разблокируете различные улучшения.`;
    },
    canSacrifice() {
      return RealityUpgrade(19).isEffectActive;
    },
    warnText() {
      if (!this.hasChoice) {
        return `На данный момент вы имеете только один вариант выбора для новых Глифов за каждую Реальность.
          Вы можете разблокировать возможность выбирать из нескольких Глифов, отменив это уведомление и
          купив Перк СТАРТ.`;
      }

      if (this.hasFilter && this.selectedGlyph === undefined) {
        return `Если вы не выберете Глиф, один будет автоматически выбран используя значения фильтра Глифов.`;
      }
      return this.selectedGlyph === undefined
        ? `Вы обязаны выбрать Глиф чтобы продолжить.`
        : null;
    },
    gained() {
      const gainedResources = [];
      gainedResources.push(`${ruQuantifyInt(
        "Реальность,Реальности,Реальностей", this.simRealities)}`);
      gainedResources.push(`${ruQuantifyInt(
        "Очко Перка,Очка Перка,Очков Перка", this.simRealities)}`);
      gainedResources.push(`${ruQuantify(
        "Машину Реальности,Машины Реальности,Машин Реальности", this.realityMachines, 2)}`);
      if (this.effarigUnlocked) {
        gainedResources.push(`${ruQuantify(
          "Осколок Реликвий,Осколка Реликвий,Осколков Реликвий", this.shardsGained, 2)}`);
      }
      return `Вы получите ${makeEnumeration(gainedResources)}`;
    },
    levelStats() {
      // Bit annoying to read due to needing >, <, and =, with = needing a different format.
      return `Вы получите Глиф уровня ${formatInt(this.level)} за Реальность, он
        ${this.level === this.bestLevel ? "такой же, как" : `
        ${ruQuantifyInt("уровень,уровня,уровней", this.levelDifference)}
        ${this.level > this.bestLevel ? "больше" : "меньше"}, чем`} ваш лучший.`;
    },
    confirmationToDisable() {
      return ConfirmationTypes.glyphSelection.isUnlocked() ? "glyphSelection" : undefined;
    },
    canConfirm() {
      return this.firstReality || this.selectedGlyph !== undefined || this.hasFilter;
    }
  },
  created() {
    this.getGlyphs();
    GlyphSelection.realityProps = getRealityProps(false, false);
  },
  methods: {
    update() {
      this.firstReality = player.realities === 0;
      this.hasChoice = Perk.firstPerk.isEffectActive;
      this.effarigUnlocked = TeresaUnlocks.effarig.canBeApplied;
      this.hasFilter = EffarigUnlock.glyphFilter.isUnlocked;
      this.level = gainedGlyphLevel().actualLevel;
      this.simRealities = 1 + simulatedRealityCount(false);
      this.hasSpace = GameCache.glyphInventorySpace.value >= this.simRealities;
      const simRMGained = MachineHandler.gainedRealityMachines.times(this.simRealities);
      this.realityMachines.copyFrom(simRMGained.clampMax(MachineHandler.distanceToRMCap));
      this.shardsGained = Effarig.shardsGained * (simulatedRealityCount(false) + 1);
      this.willAutoPurge = player.reality.autoAutoClean;
      if (this.firstReality) return;
      for (let i = 0; i < this.glyphs.length; ++i) {
        const currentGlyph = this.glyphs[i];
        const newGlyph = GlyphSelection.glyphList(
          GlyphSelection.choiceCount, gainedGlyphLevel(), { isChoosingGlyph: false }
        )[i];
        if (currentGlyph.level === newGlyph.level) continue;
        currentGlyph.level = newGlyph.level;
        currentGlyph.effects = newGlyph.effects;
      }
      this.bestLevel = player.records.bestReality.glyphLevel;
      this.levelDifference = Math.abs(this.bestLevel - this.level);
    },
    glyphClass(index) {
      return {
        "l-modal-glyph-selection__glyph": true,
        "l-modal-glyph-selection__glyph--selected": this.selectedGlyph === index,
      };
    },
    getGlyphs() {
      this.canRefresh = true;
      this.glyphs = GlyphSelection.upcomingGlyphs;
    },
    select(index) {
      this.selectedGlyph = index;
    },
    confirmModal(sacrifice) {
      if (!this.canConfirm) return;
      if (sacrifice) {
        // Sac isn't passed through confirm so we have to close it manually
        this.emitClose();
      }
      startManualReality(sacrifice, this.selectedGlyph);
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    :option="confirmationToDisable"
    :show-confirm="canConfirm"
    @confirm="confirmModal(false)"
  >
    <template #header>
      Вы собираетесь начать Реальность
    </template>
    <div
      v-if="firstReality"
      class="c-modal-message__text"
    >
      {{ firstRealityText }}
    </div>

    <div class="c-modal-message__text">
      {{ gained }}
    </div>
    <div
      v-if="!firstReality"
      class="l-glyph-selection__row"
    >
      <GlyphComponent
        v-for="(glyph, index) in glyphs"
        :key="index"
        :class="glyphClass(index)"
        :glyph="glyph"
        :is-in-modal="true"
        :ignore-modified-level="true"
        :show-sacrifice="canSacrifice"
        @click.native="select(index)"
      />
    </div>
    <div v-if="!firstReality">
      {{ levelStats }}
      <br>
      <b class="o-warning">
        {{ warnText }}
      </b>
    </div>
    <div v-if="simRealities > 1">
      <br>
      После выбора этого Глифа игра симулирует оставшиеся ваши Реальности,
      <br>
      автоматически выбирая другой {{ ruQuantifyInt("Глиф,Глифа,Глифов", simRealities - 1) }}
      основываясь на ваших настройках Фильтра Глифов.
    </div>
    <div v-if="willAutoPurge">
      <br>
      Авто-очистка на данный момент включена; ваш выбранный Глиф
      <br>
      может не появиться в вашем инвентаре после её срабатывания.
    </div>
    <div
      v-if="!hasSpace"
      class="o-warning"
    >
      <span v-if="simRealities > 1">
        Вы будете симулировать большее количество Реальностей, чем то, для которого у вас есть место в инвентаре;
        это может привести к Жертвованию некоторых Глифов.
      </span>
      <span v-else>
        У вас нет свободного места в инвентаре - ваш выбранный Глиф будет автоматически
        {{ canSacrifice ? "Жертвован" : "удалён" }}!
      </span>
    </div>
    <div v-if="confirmationToDisable">
      <br>
      Вы можете принудить это уведомление к появлению (даже если отключено) зажав Shift и нажав кнопку Реальности.
    </div>
    <template
      v-if="canSacrifice && canConfirm"
      #extra-buttons
    >
      <PrimaryButton
        class="o-primary-btn--width-medium c-modal-message__okay-btn"
        @click="confirmModal(true)"
      >
        Жертвовать
      </PrimaryButton>
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.o-warning {
  color: var(--color-infinity);
}
</style>
